import selectComponent from 'utilities/select-component'
import 'fullcalendar/dist/fullcalendar'
import 'vendor/jquery.debouncedresize'
import { $bpTablet } from 'utilities/grid-settings'

export default class Calendar {
    constructor(element, eventsUrl = '', settings = {}) {
        this.$component = selectComponent(element)

        this.view = 'month'

        if (!$bpTablet.matches) {
            this.view = 'listMonth'
        }

        this.defaultSettings = {
            defaultView: this.view,
            header: {
                center: 'title',
                right: 'prev, next',
                left: 'today'
            },
            dragScroll: false,
            height: 'auto',
            events: eventsUrl,
            businessHours: {
                start: '05:00',
                end: '23:00',
                dow: [0, 1, 2, 3, 4, 5, 6]
            },
            views: {
                basicWeek: {
                    eventLimit: false
                },
                basicDay: {
                    eventLimit: false
                }
            }
        }

        this.settings = { ...this.defaultSettings, ...settings }

        this.createCalendar()
        this.handleResize()
    }

    createCalendar() {
        this.$component.fullCalendar(this.settings)
    }

    handleResize() {
        $(window).on('debouncedresize.calendar', () => {
            this.view = 'month'

            if (!$bpTablet.matches) {
                this.view = 'listMonth'
            }
            this.$component.fullCalendar('changeView', this.view)
        })
    }
}
